module.exports = __webpack_public_path__ + "img/kala.13c5ecf7.png";